
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/channels/bridge",
      function () {
        return require("private-next-pages/channels/bridge.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/channels/bridge"])
      });
    }
  